import { FAQ_PATH, OVERVIEW_PATH, RESOURCES_PATH } from "./routes";

export const TABS = [
  { path: OVERVIEW_PATH, name: "Overview" },
  { path: FAQ_PATH, name: "FAQ" },
  { path: RESOURCES_PATH, name: "Resources" },
];

export const CF_INVITATION_CENTER = "/cf/invitation-center";
export const CF_ADD_CONTRACTOR_LINK = `${CF_INVITATION_CENTER}#contractors-or-vendors`;
export const CF_ADD_EMPLOYEES_LINK = `${CF_INVITATION_CENTER}#employees`;
export const CF_INTERNATIONAL_SOLUTIONS_CONTRACTORS_LINK =
  "/cf/international-solutions/contractors";
export const CF_INTERNATIONAL_SOLUTIONS_EMPLOYER_OF_RECORD_LINK =
  "/cf/international-solutions/employees-eor";
export const CF_COST_CALCULATOR = `https://docs.google.com/spreadsheets/d/1N5RYTHrEsQBhKDdrxtLXOtmycJ4s1tET2neWTS3f6Y8/edit?gid=0#gid=0`;

export const INTERNATIONAL_CONTRACTORS_PRODUCT_HELP_LINK =
  "https://help.justworks.com/hc/en-us/articles/18040350606619-International-Contractors";
export const INTERNATIONAL_PRODUCTS_HELP_LINK =
  "https://help.justworks.com/hc/en-us/sections/24025565585179-International-Products";
export const EOR_SWITCHING_HELP_LINK =
  "https://help.justworks.com/hc/en-us/articles/32519629621659-What-to-Expect-When-Switching-to-Justworks-as-Your-Employer-of-Record-EOR";
export const GLOBAL_HIRING_GUIDES_LINK =
  "https://www.justworks.com/global-hiring-guides";
export const JUSTWORKS_PEO_KEY_FEATURES_LINK =
  "https://help.justworks.com/hc/en-us/articles/34505385091867-Justworks-PEO-Key-Features";
export const SWITCHING_TO_JUSTWORKS_EOR_HELP_ARTICLE_LINK =
  "https://help.justworks.com/hc/en-us/articles/32519629621659-What-to-Expect-When-Switching-to-Justworks-as-Your-Employer-of-Record-EOR";
export const EMPLOYEE_OR_CONTRACTOR_RISKS_OF_MISCLASSIFICATION_LINK =
  "https://www.justworks.com/blog/employee-or-contractor-understanding-the-risks-of-misclassification";
export const CONVERT_CONTRACTOR_TO_EMPLOYEE_LINK =
  "https://www.justworks.com/blog/how-to-convert-an-international-contractor-to-a-full-time-employee";
export const JUSTWORKS_EOR_HELP_ARTICLE_LINK =
  "https://help.justworks.com/hc/en-us/articles/24026656179099-Justworks-Employer-of-Record-EOR";
export const GLOBAL_GROWTH_MADE_SIMPLE_EBOOK_LINK =
  "https://assets.ctfassets.net/mnc2gcng0j8q/3PdZiIDI9Uhm2rKSYTR1jX/9ae062aec9dc2fa9c338268f70118176/240326_International_Ebook.pdf";

export const EOR_PRICE = "$599/month per employee";
export const CONTRACTOR_PRICE = "$39/month per paid international contractor";
